import React from 'react'
import { Box, Button, Card, CardContent, Container, Grid, TextField, Typography } from '@mui/material'
function Contact() {
    return (
        <>
            <Container style={{ padding: "40px 15px" }}>
                <Grid container spacing={5} style={{ justifyContent: "space-between" }}>
                    <Grid item md={6}>
                        <Typography variant='h4' style={{ marginBottom: "15px", fontWeight: "bold", }} sx={{ fontSize: { xs: '28px', sm: '32px', md: '40px' } }}>
                            Have you any queries?
                        </Typography>
                        <Typography variant='p'>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Praesentium doloremque placeat itaque aliquid, temporibus </Typography>
                        <Box style={{ marginTop: "20px" }}>
                            <TextField
                                fullWidth
                                label="Your Full Name"
                                variant="outlined"
                                style={{ marginBottom: 20 }}
                            />
                        </Box>
                        <Box >
                            <TextField

                                fullWidth
                                label="Email Address"
                                variant="outlined"
                                style={{ marginBottom: 20 }}
                            />
                        </Box>
                        <Box >
                            <TextField
                                fullWidth
                                label="Mobile Number"
                                variant="outlined"
                                style={{ marginBottom: 20 }}
                            />
                        </Box>
                        <Box >
                            <TextField
                                fullWidth
                                label="Message"
                                variant="outlined"
                                style={{ marginBottom: 20 }}
                            />
                        </Box>
                        <Button
                            fullWidth
                            variant="contained"
                            color="primary"
                            sx={{ py: 1.5, mt: 2, fontSize: '16px', fontWeight: 'bold' }}
                        >
                            Submit Message
                        </Button>
                    </Grid>
                    <Grid item md={6}>

                        <Card style={{ width: "100%", height: "100%" }}>
                            <CardContent>
                                <Box
                                    component="img"
                                    sx={{
                                        height: "100%",
                                        width: "100%",
                                        margin: ' auto'
                                    }}
                                    alt="The house from the offer."
                                    src="./assets/image/contact_us.jpg"
                                />

                                <Box style={{ margin: "20px 0" }}>
                                    <Typography variant="h5" component="div">
                                        Head Office
                                    </Typography>
                                    <Typography variant="p" component="div">
                                        Saltlake, Sector V, Bidhannagar, Kolkata, West Bengal 700091
                                    </Typography>
                                </Box>
                                <Box style={{ margin: "20px 0" }}>
                                    <Typography variant="h5" component="div">
                                        Email Address
                                    </Typography>
                                    <Typography variant="p" component="div">
                                        example@company.com
                                    </Typography>
                                </Box>
                                <Box style={{ margin: "20px 0" }}>
                                    <Typography variant="h5" component="div">
                                        Phone Number
                                    </Typography>
                                    <Typography variant="p" component="div">
                                        +91 9958 996 222
                                    </Typography>
                                </Box>
                            </CardContent>
                        </Card>

                    </Grid>
                </Grid>
            </Container >
        </>
    )
}

export default Contact